import { render, staticRenderFns } from "./modal_update.vue?vue&type=template&id=2675c576&scoped=true&"
import script from "./modal_update.vue?vue&type=script&lang=js&"
export * from "./modal_update.vue?vue&type=script&lang=js&"
import style0 from "./modal_update.vue?vue&type=style&index=0&id=2675c576&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2675c576",
  null
  
)

export default component.exports